import styled from 'styled-components'

const CascadeHover = styled.div``

export {CascadeHover}
